import { defineComponent as d, openBlock as a, createElementBlock as o, mergeProps as p, unref as l, renderSlot as i, createElementVNode as e, createCommentVNode as h } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const m = { key: 0 }, A = { key: 1 }, g = { key: 2 }, v = { key: 3 }, Z = { key: 4 }, f = { key: 5 }, M = {
  name: "ScalarIconSignpost"
}, y = /* @__PURE__ */ d({
  ...M,
  props: {
    label: {},
    weight: {}
  },
  setup(s) {
    const r = s, { bind: V, weight: n } = u(r);
    return (H, t) => (a(), o("svg", p({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, l(V)), [
      i(H.$slots, "default"),
      l(n) === "bold" ? (a(), o("g", m, t[0] || (t[0] = [
        e("path", { d: "M248.92,104,215.3,66.62A20,20,0,0,0,200.44,60H140V32a12,12,0,0,0-24,0V60H40A20,20,0,0,0,20,80v64a20,20,0,0,0,20,20h76v60a12,12,0,0,0,24,0V164h60.44a20,20,0,0,0,14.86-6.62L248.92,120A12,12,0,0,0,248.92,104Zm-50.26,36H44V84H198.66l25.2,28Z" }, null, -1)
      ]))) : l(n) === "duotone" ? (a(), o("g", A, t[1] || (t[1] = [
        e("path", {
          d: "M240,112l-33.62,37.35a8,8,0,0,1-5.94,2.65H40a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8H200.44a8,8,0,0,1,5.94,2.65Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M246,106.65,212.33,69.3A16,16,0,0,0,200.44,64H136V32a8,8,0,0,0-16,0V64H40A16,16,0,0,0,24,80v64a16,16,0,0,0,16,16h80v64a8,8,0,0,0,16,0V160h64.44a16,16,0,0,0,11.89-5.3L246,117.35A8,8,0,0,0,246,106.65ZM200.44,144H40V80H200.44l28.8,32Z" }, null, -1)
      ]))) : l(n) === "fill" ? (a(), o("g", g, t[2] || (t[2] = [
        e("path", { d: "M246,117.35,212.33,154.7a16,16,0,0,1-11.89,5.3H136v64a8,8,0,0,1-16,0V160H40a16,16,0,0,1-16-16V80A16,16,0,0,1,40,64h80V32a8,8,0,0,1,16,0V64h64.44a16,16,0,0,1,11.89,5.3L246,106.65A8,8,0,0,1,246,117.35Z" }, null, -1)
      ]))) : l(n) === "light" ? (a(), o("g", v, t[3] || (t[3] = [
        e("path", { d: "M244.46,108,210.84,70.63A14,14,0,0,0,200.44,66H134V32a6,6,0,0,0-12,0V66H40A14,14,0,0,0,26,80v64a14,14,0,0,0,14,14h82v66a6,6,0,0,0,12,0V158h66.44a14,14,0,0,0,10.4-4.63L244.46,116A6,6,0,0,0,244.46,108Zm-42.54,37.35a2,2,0,0,1-1.48.66H40a2,2,0,0,1-2-2V80a2,2,0,0,1,2-2H200.44a2,2,0,0,1,1.48.66l30,33.34Z" }, null, -1)
      ]))) : l(n) === "regular" ? (a(), o("g", Z, t[4] || (t[4] = [
        e("path", { d: "M246,106.65,212.33,69.3A16,16,0,0,0,200.44,64H136V32a8,8,0,0,0-16,0V64H40A16,16,0,0,0,24,80v64a16,16,0,0,0,16,16h80v64a8,8,0,0,0,16,0V160h64.44a16,16,0,0,0,11.89-5.3L246,117.35A8,8,0,0,0,246,106.65ZM200.44,144H40V80H200.44l28.8,32Z" }, null, -1)
      ]))) : l(n) === "thin" ? (a(), o("g", f, t[5] || (t[5] = [
        e("path", { d: "M243,109.32,209.36,72a12.06,12.06,0,0,0-8.92-4H132V32a4,4,0,0,0-8,0V68H40A12,12,0,0,0,28,80v64a12,12,0,0,0,12,12h84v68a4,4,0,0,0,8,0V156h68.44a12.06,12.06,0,0,0,8.92-4L243,114.68A4,4,0,0,0,243,109.32Zm-39.56,37.36a4,4,0,0,1-3,1.32H40a4,4,0,0,1-4-4V80a4,4,0,0,1,4-4H200.44a4,4,0,0,1,3,1.32L234.62,112Z" }, null, -1)
      ]))) : h("", !0)
    ], 16));
  }
});
export {
  y as default
};
